import { ChangeDetectorRef, Component, Inject, Optional, ViewContainerRef } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { iif, noop, Observable, of, throwError } from 'rxjs';
import { concatMap, filter, map, pluck, switchMap, tap, flatMap } from 'rxjs/operators';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';
import { RedirectTransactionService } from '../../shared/services/business-transaction/redirect-transaction.service';
import { AAMVAIntegrationService } from '../../titleregistration/services/aamvaIntegration.service';
import { BusinessTransactionValidationRequest } from '../models/business-transaction-validation-request';
import { NewBusinessTransaction } from '../models/new-business-transaction.model';
import { CheckinService } from '../services/checkin.service';
import { WIPStatusType } from '../../wip/models/enums/w-i-p-status-type.enum';

export class TransactionPrequalServiceAddContext {
    constructor(public value: BusinessTransactionValidationRequest,
        public servicesAdd: boolean,
        public serviceRequirementId: number,
        public customerNumberId: number,
        public aircraftId: number,
        public businessTransactionNumberIds: number[],
        public newBusinessTransactions: NewBusinessTransaction[],
        public agentId: number) { }
}

export class TransactionPrequalServiceExistingContext extends TransactionPrequalServiceAddContext {
    public businessTransactionNumberId: number;
    public holdTransactions?: boolean;
    public queuedTransactions?: boolean;
    public businessTransactionSnapShotIds: number[];
}

export class TransactionPrequalSidebarContext {
    constructor(public businessTransactionNumberId: string,
        public sideBar: boolean) { }
}

@Component({
    selector: 'transaction-validation-modal',
    templateUrl: './transaction-prequal-modal.html'
})
export class TransactionPrequalWindowComponent {
    public showPrequal: boolean;
    private model: BusinessTransactionValidationRequest;
    public validation: any;
    public transactionTypeId: any;
    public transactionNumberId: string;
    public customerNumberId: number;
    public serviceRequirementId: number;
    public aircraftId: number;
    public businessTransactionParamId: number;
    public businessTransactionParamTypeId: number;
    public wipStatusType: WIPStatusType = new WIPStatusType();

    constructor(
        public dialogRef: MatDialogRef<TransactionPrequalWindowComponent>,

        // This is the incoming data object supplied by each business transaction area
        @Optional() @Inject(MAT_DIALOG_DATA) public businessTransactionPrequalData: any,
        public viewContainer: ViewContainerRef,
        private redirectTransactionService: RedirectTransactionService,
        private checkinService: CheckinService,
        private businessTransactionService: BusinessTransactionService,
        private aamvaIntegrationService: AAMVAIntegrationService,
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router
    ) { }

    async ngOnInit() {
        this.model = new BusinessTransactionValidationRequest();
        this.showPrequal = false;
        this.transactionTypeId = this.businessTransactionPrequalData.businessTransactionTypeId ? parseInt(this.businessTransactionPrequalData.businessTransactionTypeId) : undefined;

        const businessTransactionId = this.businessTransactionPrequalData.businessTransactionNumberId ? parseInt(this.businessTransactionPrequalData.businessTransactionNumberId) : undefined;
        this.model.businessTransactionId = businessTransactionId;
        this.model.businesstransactionValidationMode = 2;
        let wipStatus: number;

        if (businessTransactionId) {
            this.businessTransactionService.getTransactionMetaData(businessTransactionId.toString())
                .subscribe(
                    result => {
                        const customerObject = result.itemKeyCollection.filter(x => {
                            if (x.businessTransactionItemKeyTypeId == 1) {
                                return x.itemKeyId;
                            }
                        });
                        const serviceRequirementObject = result.itemKeyCollection.filter(x => {
                            if (x.businessTransactionItemKeyTypeId == 2) {
                                return x.itemKeyId;
                            }
                        });
                        const aircraftObject = result.itemKeyCollection.filter(x => {
                            if (x.businessTransactionItemKeyTypeId == 27) {
                                return x.itemKeyId;
                            }
                        });
                        wipStatus = result.wipStatusTypeId;

                        this.transactionNumberId = result.id;
                        if (customerObject.length != 0) {
                            this.customerNumberId = customerObject[0].itemKeyId;
                        }
                        if (serviceRequirementObject.length != 0) {
                            this.serviceRequirementId = serviceRequirementObject[0].itemKeyId;
                        }
                        if (aircraftObject.length != 0) {
                            this.aircraftId = aircraftObject[0].itemKeyId;
                        }
                        this.transactionTypeId = result.businessTransactionTypeId;

                        this.changeDetectorRef.detectChanges();

                        if (this.businessTransactionPrequalData.queuedTransactions || this.businessTransactionPrequalData.holdTransactions) {
                            this.prepareServicesForPrequal();
                        } else {
                            this.prepareForPrequal(wipStatus);
                        }
                    },
                    error => this.handleError(error)
                );
        } else {
            this.prepareForPrequal(wipStatus);
        }
    }

    accept(result: any) {

        if (this.businessTransactionPrequalData.servicesAdd && result.businessTransactionId) {
            this.businessTransactionService.assignBusinessTransactionsToUser(result.businessTransactionId, 0, true).subscribe(
                () => this.redirectTransactionService.redirectToTransaction(result.businessTransactionId, this.viewContainer),
                error => this.handleError(error)
            );
        } else {
            this.dialogRef.close(result);
        }
    }

    cancel() {
        this.dialogRef.close();

        if ((true == this.showPrequal) && (this.businessTransactionPrequalData.servicesAdd)) {
            this.router.navigate(['/transaction/queues']);
        }
    }

    /**
     * Prepares any additional data requirements to the initial data supplied to the modal
     * This is handled by area to determine which data is required to be set.
     * */
    prepareAdditionalOutputData(prequalData: any) {

        // IRP
        if (prequalData.businessTransactionAreaId == 11) {
            this.businessTransactionPrequalData.itemKeys = prequalData.itemKeys;
        }
    }

    /**
     * This method handles the data coming from the transaction prequal component that is responsible for performing
     * the prequal functions.
     * The prequalData may not always be returned back to the caller depending on where the prequal was initiated from.
     * Ex. MegaMenu will return the prequalData as returned by the transaction prequal.  SideBar will return the initial data supplied
     * to the modal
     * */
    handleEmit(prequalData: any) {
        if (prequalData) {

            if (this.businessTransactionPrequalData.sideBar) {
                this.accept(this.businessTransactionPrequalData);
            } else if (this.businessTransactionPrequalData.megaMenu) {
                this.startTransaction(prequalData);
            } else if (this.businessTransactionPrequalData.servicesAdd) {
                this.accept(prequalData);
            } else if (this.businessTransactionPrequalData.holdTransactions || this.businessTransactionPrequalData.queuedTransactions) {
                this.showPrequal = false;
                this.startServices([this.businessTransactionPrequalData.businessTransactionNumberId], [])
                    .subscribe(
                        () => noop,
                        err => this.handleError(err)
                    );
            } else if (this.businessTransactionPrequalData.showPrequal) {

                this.prepareAdditionalOutputData(prequalData);

                this.dialogRef.close(this.businessTransactionPrequalData);

            } else {
                this.showPrequal = false;
                this.redirectTransaction(this.businessTransactionPrequalData.businessTransactionNumberId);
            }
        }
    }

    private handleError(error: any) {
        this.validation = error;
        this.showPrequal = true;
    }

    private invokePrequal(item: BusinessTransactionValidationRequest, businessTransactionIds: number[], newBusinessTransactions: NewBusinessTransaction[]) {
        this.checkinService.validatePrequal(item)
            .pipe(
                switchMap(
                    (result: BusinessTransactionValidationRequest) =>
                        iif(() => (result.validationResults) && (result.validationResults.length > 0),
                            throwError(result),
                            of(result))
                ),
                tap(() => this.businessTransactionPrequalData.holdTransactions ? this.startNmvtisTransactionForHold() : noop),
                switchMap(() => this.transactionCanBeStarted() ?
                    this.startServices(businessTransactionIds, newBusinessTransactions) :
                    this.redirectTransaction(this.businessTransactionPrequalData.businessTransactionNumberId))
            )
            .subscribe(
                () => noop,
                error => this.handleError(error)
            );
    }

    private prepareServicesForPrequal() {
        const newBusinessTransactions = this.businessTransactionPrequalData.newBusinessTransactions ? this.businessTransactionPrequalData.newBusinessTransactions : [];
        this.invokePrequal(this.model, this.businessTransactionPrequalData.businessTransactionSnapShotIds, newBusinessTransactions);
    }

    private prepareForPrequal(wipStatus: number) {
        const newBusinessTransactions = this.businessTransactionPrequalData.newBusinessTransactions ? this.businessTransactionPrequalData.newBusinessTransactions : [];

        if (this.businessTransactionPrequalData.servicesAdd) {
            const servicesAddData = this.businessTransactionPrequalData as TransactionPrequalServiceAddContext;
            this.serviceRequirementId = servicesAddData.serviceRequirementId;
            this.customerNumberId = servicesAddData.customerNumberId;
            this.aircraftId = servicesAddData.aircraftId;
            this.transactionTypeId = servicesAddData.value.businessTransactionTypeId;
            this.invokePrequal(servicesAddData.value, servicesAddData.businessTransactionNumberIds, newBusinessTransactions);
        } else if (this.businessTransactionPrequalData.sideBar) {
            of(wipStatus)
                .pipe(
                    switchMap(wipStatus => <Observable<any>> iif(() => !!wipStatus && this.statusAwaitingPostPaymentOrBeyond(wipStatus),
                        of(wipStatus),
                        this.checkinService.validatePrequal(this.model)))
                )
                .subscribe(
                    () => this.accept(this.businessTransactionPrequalData),
                    error => this.handleError(error));
        } else if (this.businessTransactionPrequalData.showPrequal) {
            this.customerNumberId = this.businessTransactionPrequalData.customerNumberId;
            this.businessTransactionParamId = this.businessTransactionPrequalData.businessTransactionParamId;
            this.businessTransactionParamTypeId = this.businessTransactionPrequalData.businessTransactionParamTypeId;
            this.showPrequal = true;
        } else if (!this.businessTransactionPrequalData.megaMenu) {
            this.invokePrequal(this.model, [this.businessTransactionPrequalData.businessTransactionNumberId], newBusinessTransactions);
        } else {
            this.showPrequal = true;
        }
    }

    private statusAwaitingPostPaymentOrBeyond(wipStatus: number) {
        // awaiting post payment, finalized, await post finalize and complete
        return wipStatus === this.wipStatusType.AwaitingPostPayment.id ||
            wipStatus === this.wipStatusType.AwaitingPostFinalize.id ||
            wipStatus === this.wipStatusType.Finalized.id ||
            wipStatus === this.wipStatusType.ServiceComplete.id;
    }

    private redirectTransaction(businessTransactionNumberId: string): Observable<any> {
        return of(this.redirectTransactionService.redirectToTransaction(businessTransactionNumberId, this.viewContainer));
    }

    private startNmvtisTransactionForHold() {
        this.aamvaIntegrationService.startNmvtisTransactionForHold(+this.transactionNumberId, this.transactionTypeId)
            .subscribe();
    }

    private startServices(businessTransactionIds: number[], newBusinessTransactions: NewBusinessTransaction[]) {
        return this.checkinService.startServices(businessTransactionIds, this.businessTransactionPrequalData.agentId, newBusinessTransactions)
            .pipe(
                pluck('businessTransactionIds'),
                filter(businessTransactionIds => businessTransactionIds && businessTransactionIds.length > 0),
                map(businessTransactionNumberIds => businessTransactionNumberIds.shift()),
                switchMap(businessTransactionId => this.redirectTransaction(businessTransactionId))
            );
    }

    private startTransaction(validationRequest: BusinessTransactionValidationRequest) {
        // start a new transaction if the businessTransactionId is falsy (e.g., if it equals 0)
        if (!validationRequest.businessTransactionId) {
            this.startNewTransaction(validationRequest);
            // otherwise close the model with the results
        } else {
            this.accept(validationRequest);
        }
    }

    private startNewTransaction(validationRequest: BusinessTransactionValidationRequest) {
        const businessTranasction = new NewBusinessTransaction();
        let businessTransactionNumberId: string;

        businessTranasction.businessTransactionAreaId = validationRequest.businessTransactionAreaId;
        businessTranasction.businessTransactionTypeId = validationRequest.businessTransactionTypeId;

        businessTranasction.customerNumberId = validationRequest.itemKeys[0].itemKeyId;
        businessTranasction.agentId = validationRequest.itemKeys[0].itemKeyId;

        if (validationRequest.itemKeys.length > 1) {
            businessTranasction.businessTransactionParamId = validationRequest.itemKeys[1].itemKeyId;
        }

        const newBusinessTransactions = new Array<NewBusinessTransaction>();
        newBusinessTransactions.push(businessTranasction);

        this.checkinService.checkin(null, businessTranasction.customerNumberId, newBusinessTransactions).pipe(
            concatMap(r => {
                businessTransactionNumberId = r.businessTransactionIds[0].toString();
                return this.businessTransactionService.assignBusinessTransactionsToUser(businessTransactionNumberId, 0, true);
            }))
            .subscribe(
                () => this.redirectTransactionService.redirectToTransaction(businessTransactionNumberId, this.viewContainer),
                error => this.handleError(error)
            );
    }

    private transactionCanBeStarted() {
        return !!this.businessTransactionPrequalData.servicesAdd || !!this.businessTransactionPrequalData.holdTransactions || !!this.businessTransactionPrequalData.queuedTransactions;
    }
}
